module.exports = require('./xhr')


/*****************
 ** WEBPACK FOOTER
 ** ./src/mock/xhr/index.js
 ** module id = 27
 ** module chunks = 0
 **/